import { routes } from "@/lib/routes";

/** Normalize an auth return destination without allowing another origin. */
export function getSafeReturnPath(value: string | null | undefined, origin: string): string {
  if (!value || value.trim() !== value || /[\u0000-\u001f\u007f\\]/.test(value)) {
    return routes.home;
  }

  try {
    const base = new URL(origin);
    const destination = new URL(value, base);
    if (
      destination.origin !== base.origin ||
      !["http:", "https:"].includes(destination.protocol) ||
      destination.username ||
      destination.password ||
      destination.pathname.startsWith("//")
    ) {
      return routes.home;
    }
    return destination.pathname + destination.search + destination.hash;
  } catch {
    return routes.home;
  }
}
